import { Link } from 'react-router-dom';
import Footer from './Footer';

const DemoSelection = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2">
              <img src="/apple-touch-icon.png" alt="EightyThreeLabs" className="w-8 h-8" />
              <span className="text-xl font-semibold">
                <span className="text-brand-primary">EightyThree</span>
                <span className="text-black dark:text-white">Labs</span>
              </span>
            </Link>
            
            <Link 
              to="/login" 
              className="bg-brand-primary text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              Get Started
            </Link>
          </div>
        </div>
      </header>

      {/* Demo Selection Content */}
      <div className="max-w-5xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 dark:text-gray-100 mb-4">
            Choose Your Demo Game
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Try any of our brain training games - no signup required! Each game challenges different cognitive skills.
          </p>
        </div>

        {/* Game Selection Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">

          {/* Sum Grid */}
          <Link 
            to="/sum-grid" 
            className="group bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 border-2 border-transparent hover:border-green-500"
          >
            <div className="text-center">
              <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">🧩</div>
              <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3">Sum Grid</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                Logic puzzle: place numbers so rows and columns add to targets
              </p>
              <div className="bg-green-50 dark:bg-green-900/50 rounded-lg p-2 text-xs text-green-700 dark:text-green-300 font-medium">
                🧠 Logic & Strategy
              </div>
            </div>
          </Link>

          {/* Multiplication Grid */}
          <Link 
            to="/multiplication-grid" 
            className="group bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 border-2 border-transparent hover:border-purple-500"
          >
            <div className="text-center">
              <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">✖️</div>
              <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3">Multiplication Grid</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                Fill grid so rows and columns multiply to target products
              </p>
              <div className="bg-purple-50 dark:bg-purple-900/50 rounded-lg p-2 text-xs text-purple-700 dark:text-purple-300 font-medium">
                ✖️ Times Tables
              </div>
            </div>
          </Link>

          {/* Combined Grid */}
          <Link 
            to="/combined-grid" 
            className="group bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 border-2 border-transparent hover:border-orange-500"
          >
            <div className="text-center">
              <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">➕✖️</div>
              <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3">Combined Grid</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                Ultimate challenge: satisfy BOTH sum and product constraints
              </p>
              <div className="bg-orange-50 dark:bg-orange-900/50 rounded-lg p-2 text-xs text-orange-700 dark:text-orange-300 font-medium">
                🔥 Expert Level
              </div>
            </div>
          </Link>

          {/* Mental Math Speed Round */}
          <Link 
            to="/mental-math-speed" 
            className="group bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 border-2 border-transparent hover:border-pink-500"
          >
            <div className="text-center">
              <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">🧠</div>
              <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3">Speed Math</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                60-second rapid-fire arithmetic challenge
              </p>
              <div className="bg-pink-50 dark:bg-pink-900/50 rounded-lg p-2 text-xs text-pink-700 dark:text-pink-300 font-medium">
                ⚡ Speed Round
              </div>
            </div>
          </Link>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            Like what you see? Get full access to all games and track your progress!
          </p>
          <Link 
            to="/signup" 
            className="inline-block bg-brand-primary text-white px-8 py-3 rounded-xl font-bold text-lg hover:bg-green-700 transition-colors shadow-lg"
          >
            🚀 Get Started
          </Link>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default DemoSelection;